module.exports = __webpack_public_path__ + "static/media/illustration-sample.c0e1e2f2.jpg";